(() => {
  const normalise = (value) => (value || '')
    .toLocaleLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

  const initHelpHub = (root) => {
    if (!root || root.dataset.helpReady === 'true') return;
    root.dataset.helpReady = 'true';

    const form = root.querySelector('[data-help-form]');
    const input = root.querySelector('[data-help-search]');
    const clear = root.querySelector('[data-help-clear]');
    const status = root.querySelector('[data-help-status]');
    const empty = root.querySelector('[data-help-empty]');
    const items = [...root.querySelectorAll('[data-help-searchable]')];
    const answers = [...root.querySelectorAll('.auv-help__accordion > details')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const initReturnForm = () => {
      const portal = root.querySelector('[data-return-portal]');
      if (!portal || portal.dataset.returnReady === 'true') return;
      portal.dataset.returnReady = 'true';

      const form = portal.querySelector('form');
      const reason = portal.querySelector('[data-return-reason]');
      const issueNote = portal.querySelector('[data-return-issue-note]');
      const message = portal.querySelector('[data-return-message]');
      const count = portal.querySelector('[data-return-count]');
      const submit = portal.querySelector('[data-return-submit]');
      const submitLabel = portal.querySelector('[data-return-submit-label]');
      const success = portal.querySelector('[data-return-success]');
      const errors = portal.querySelector('.auv-help__return-errors');

      const updateIssueNote = () => {
        if (!reason || !issueNote) return;
        const selected = reason.options[reason.selectedIndex];
        issueNote.hidden = !selected?.hasAttribute('data-return-issue');
      };

      const updateCount = () => {
        if (message && count) count.textContent = `${message.value.length} / 1000`;
      };

      reason?.addEventListener('change', updateIssueNote);
      message?.addEventListener('input', updateCount);
      updateIssueNote();
      updateCount();

      form?.addEventListener('submit', () => {
        if (!submit || !submitLabel) return;
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        submitLabel.textContent = submit.dataset.loadingLabel || submitLabel.textContent;
      });

      const responsePanel = success || errors;
      if (responsePanel) {
        window.setTimeout(() => {
          responsePanel.focus({ preventScroll: true });
          portal.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        }, 80);
      }
    };

    const filter = (value) => {
      const query = normalise(value);
      const terms = query.split(/\s+/).filter(Boolean);
      let resultCount = 0;

      items.forEach((item) => {
        const haystack = normalise((item.dataset.search || '') + ' ' + (item.textContent || ''));
        const matches = !terms.length || terms.every((term) => haystack.includes(term));
        item.hidden = !matches;
        if (matches && !item.matches('[data-help-term]')) resultCount += 1;
      });

      clear.hidden = !query;
      empty.hidden = !query || resultCount > 0;
      status.textContent = query
        ? (resultCount === 1 ? root.dataset.resultOne : String(resultCount) + ' ' + root.dataset.resultMany)
        : '';
    };

    const goToSection = (targetId, updateHash = true) => {
      const allowedTargets = ['help-shipping', 'help-returns', 'help-return-form', 'help-faq', 'help-contact'];
      if (!allowedTargets.includes(targetId)) return false;

      const resolvedTargetId = targetId === 'help-returns' ? 'help-return-form' : targetId;
      const target = document.getElementById(resolvedTargetId);
      if (!target || !root.contains(target)) return false;

      if (input) input.value = '';
      filter('');

      if (updateHash && window.location.hash !== `#${resolvedTargetId}`) {
        window.history.pushState(null, '', `#${resolvedTargetId}`);
      }

      target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      const heading = target.querySelector('h2, h3');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        window.setTimeout(() => heading.focus({ preventScroll: true }), reducedMotion ? 0 : 350);
      }
      return true;
    };

    form?.addEventListener('submit', (event) => event.preventDefault());
    input?.addEventListener('input', () => filter(input.value));

    clear?.addEventListener('click', () => {
      input.value = '';
      filter('');
      input.focus();
    });

    root.querySelectorAll('[data-help-term]').forEach((button) => {
      button.addEventListener('click', () => {
        const targetId = button.dataset.helpTarget;
        if (targetId && goToSection(targetId)) return;

        const term = button.dataset.helpTerm || '';
        input.value = term;
        filter(term);
        root.querySelector('.auv-help__answers')?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        const firstMatch = answers.find((item) => !item.hidden);
        if (firstMatch) firstMatch.open = true;
      });
    });

    root.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#help-"]');
      if (!link || !root.contains(link)) return;
      if (goToSection(link.hash.slice(1))) event.preventDefault();
    });

    answers.forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        answers.forEach((other) => {
          if (other !== details) other.open = false;
        });
      });
    });

    const openHashTarget = () => {
      const targetId = window.location.hash.replace(/^#/, '');
      if (targetId) window.setTimeout(() => goToSection(targetId, false), 60);
    };

    window.addEventListener('hashchange', openHashTarget);
    openHashTarget();
    initReturnForm();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-auv-help]').forEach(initHelpHub);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
